import { Link } from "react-router-dom";

/**
 * Custom typographic Pixelkare logo:
 *  "PixelKar" + last "e" with a small "ai" superscript hovering above it.
 *  No icon — pure type.
 */
export default function Logo({ className = "" }) {
  return (
    <Link
      to="/"
      data-testid="brand-logo"
      className={`inline-flex items-baseline group select-none ${className}`}
      aria-label="PixelKare — AI app development"
    >
      <span className="font-display text-2xl md:text-[1.7rem] tracking-tight text-[#0a0a0a] leading-none">
        PixelKar
      </span>
      <span className="relative inline-block">
        <span className="font-display text-2xl md:text-[1.7rem] tracking-tight text-[#0a0a0a] leading-none">
          e
        </span>
        <span
          aria-hidden="true"
          className="absolute -top-2 md:-top-2.5 left-1/2 -translate-x-1/2 font-mono text-[0.55rem] md:text-[0.6rem] font-semibold tracking-[0.05em] text-[#1f87bc] leading-none"
        >
          ai
        </span>
      </span>
    </Link>
  );
}
